
export type ErrorDetail = {
  key: string;
  value: string;
};

export enum ErrorLevel {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  NONE = 'NONE',

}
export enum ErrorType {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
  EXTERNAL = 'EXTERNAL',

}

export type ErrorParams = {
  message: string;
  errorType: ErrorType;
  errorLevel: ErrorLevel;
  errorDetails?: ErrorDetail[];
};
